export class MailTemplate {
  subject: string;
  message: string;
  height: number;

  constructor() {
    this.subject = '';
    this.message = '';
    this.height = 300;
  }

}